import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type SortMode = 'heat' | 'trend' | 'value' | 'defensibility' | 'recent' | 'name'

interface UIState {
  search: string
  filterEntity: string | 'all'
  filterStatus: string | 'all'
  filterCategory: string | 'all'
  sortMode: SortMode
  view: 'grid' | 'table'
  setSearch: (s: string) => void
  setFilterEntity: (e: string) => void
  setFilterStatus: (s: string) => void
  setFilterCategory: (c: string) => void
  setSortMode: (m: SortMode) => void
  setView: (v: 'grid' | 'table') => void
  reset: () => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      search: '',
      filterEntity: 'all',
      filterStatus: 'all',
      filterCategory: 'all',
      sortMode: 'heat',
      view: 'grid',
      setSearch: (search) => set({ search }),
      setFilterEntity: (filterEntity) => set({ filterEntity }),
      setFilterStatus: (filterStatus) => set({ filterStatus }),
      setFilterCategory: (filterCategory) => set({ filterCategory }),
      setSortMode: (sortMode) => set({ sortMode }),
      setView: (view) => set({ view }),
      reset: () => set({
        search: '', filterEntity: 'all', filterStatus: 'all',
        filterCategory: 'all', sortMode: 'heat', view: 'grid',
      }),
    }),
    { name: 'arh-acq-ui-v1' }
  )
)
